import { render, staticRenderFns } from "./FavorabilityIconSvg.vue?vue&type=template&id=62faec5d&scoped=true"
import script from "./FavorabilityIconSvg.vue?vue&type=script&setup=true&lang=js"
export * from "./FavorabilityIconSvg.vue?vue&type=script&setup=true&lang=js"
import style0 from "./FavorabilityIconSvg.vue?vue&type=style&index=0&id=62faec5d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62faec5d",
  null
  
)

export default component.exports